/**
 * 通用的复制文本函数
 * @param {string} text - 要复制的文本内容
 * @returns {Promise<void>} - 返回一个Promise，复制成功时resolve，失败时reject
 */
export const copyToClipboard = async (text) => {
    try {
        // 优先使用现代的Clipboard API
        if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(text);
            return;
        }

        // 降级方案：使用document.execCommand
        const textArea = document.createElement('textarea');
        textArea.value = text;

        // 防止滚动
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        // 执行复制命令
        const successful = document.execCommand('copy');
        textArea.remove();

        if (!successful) {
            throw new Error('复制失败');
        }
    } catch (err) {
        console.error('复制失败:', err);
        throw new Error('复制失败');
    }
};

// 字节格式化函数
export function formatBytes(bytes) {
    if (bytes == 0 || bytes === '-' || bytes == null) return '-';
    if (isNaN(bytes)) return bytes;
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const absBytes = Math.abs(bytes);
    const i = Math.floor(Math.log(absBytes) / Math.log(k));
    const value = parseFloat((absBytes / Math.pow(k, i)).toFixed(2));
    const sign = bytes < 0 ? '-' : '';
    return sign + value + ' ' + sizes[i];
}